// Import libs
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import QueryString from 'query-string';

// Import assets
import './homeView.scss';

// Import components
import TileContainer from '../../Components/Tiles/TileContainer/TileContainerController';
import LoadMoreView from '../../Components/Util/LoadMore/LoadMoreView';
import HeadlineModuleView from '../../Components/Modules/HeadlineModule/HeadlineModuleView';
import TextModuleView from '../../Components/Modules/TextModule/TextModuleView';
import { setLang } from '../../Base/Actions/globalActions';
import { fetchTiles, fetchFilteredTiles, setActiveSubCategories, resetTiles, setScrollPosition, fetchSearchededTiles } from '../../Base/Actions';
import LenspireView from '../LenspireView';

class HomeView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initial: true,
      scrollPosition: 0,
      loadMore: false,
    };

    this.loadMore = this.loadMore.bind(this);
    this.scrollHandler = this.scrollHandler.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.isLoading) {
      if ((this.filterHasChanged(nextProps)) || nextProps.match.params.search !== this.props.match.params.search || this.state.initial) {
        this.props.resetTiles();
        this.setState({
          initial: false,
          loadMore: false,
        });
        this.fetchTiles(nextProps, 0);
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    return this.props.tilesData.length === 0 || JSON.stringify(this.props.tilesData) !== JSON.stringify(nextProps.tilesData);
  }

  componentDidUpdate() {
    if (!this.state.loadMore) {
      window.scrollTo(0, this.props.scrollPosition);
    }
  }

  componentWillUnmount() {
    this.props.setScrollPosition(this.state.scrollPosition);
    window.removeEventListener('scroll', this.scrollHandler);
  }

  setCategoriesActive(categories) {
    const filter = [];
    const activeSubCategories = {};

    Object.keys(categories).map((taxonomy) => {
      if (Array.isArray(categories[taxonomy])) {
        for (let i = 0; i < categories[taxonomy].length; i += 1) {
          filter.push({ taxonomy, slug: categories[taxonomy][i] });
          activeSubCategories[categories[taxonomy][i]] = { taxonomy, slug: categories[taxonomy][i] };
        }
      } else {
        filter.push({ taxonomy, slug: categories[taxonomy] });
        activeSubCategories[categories[taxonomy]] = { taxonomy, slug: categories[taxonomy] };
      }
      return null;
    });

    this.props.setActiveSubCategories(activeSubCategories);
    return filter;
  }

  scrollHandler() {
    this.setState({
      scrollPosition: document.documentElement.scrollTop,
    });
  }

  filterHasChanged(props) {
    let changed = false;
    if (props.location.hash !== this.props.location.hash ||
      props.match.params.category !== this.props.match.params.category ||
      props.match.params.author !== this.props.match.params.author) {
      changed = true;
    }
    return changed;
  }

  fetchTilesFromCategories(category, page) {
    const obj = { category };

    const filter = this.setCategoriesActive(obj);

    this.props.fetchFilteredTiles(this.props.match.params.lang, filter, page);
  }

  fetchTilesFromAuthor(author, page) {
    const obj = { author };

    const filter = this.setCategoriesActive(obj);

    this.props.fetchFilteredTiles(this.props.match.params.lang, filter, page);
  }

  fetchTilesFromHash(newHash, page) {
    const hash = QueryString.parse(newHash);
    const filter = this.setCategoriesActive(hash);

    this.props.fetchFilteredTiles(this.props.match.params.lang, filter, page);
  }

  fetchTilesFromSearch(search, page) {
    this.props.fetchSearchededTiles(this.props.lang, search, page);
  }

  fetchTiles(props, page) {
    if (props.match.params.category) {
      const categories = props.match.params.category.split(',');
      this.fetchTilesFromCategories(categories, page);
    } else if (props.match.params.author) {
      const authors = props.match.params.author.split(',');
      this.fetchTilesFromAuthor(authors, page);
    } else if (props.match.params.search) {
      this.fetchTilesFromSearch(props.match.params.search, page);
    } else {
      this.fetchTilesFromHash(props.location.hash, page);
    }
  }

  loadMore() {
    if (this.props.hasNextPage && !this.props.isLoading) {
      this.fetchTiles(this.props, this.props.page);

      this.setState({
        loadMore: true,
      });
    }
  }

  render() {
    if (this.props.tilesData.length > 0) {
      if (this.props.page === 1) {
        return (
          <LenspireView {...this.props} >
            <TileContainer tilesData={this.props.tilesData} />
            {(() => {
              if (this.props.hasNextPage) {
                return (<LoadMoreView isDisabled onClick={this.loadMore} />);
              }
              return null;
            })()}
          </LenspireView>
        );
      }
      return (
        <LenspireView {...this.props} onScroll={this.loadMore} disableLoader>
          <TileContainer tilesData={this.props.tilesData} />
          {(() => {
            if (this.props.hasNextPage) {
              return (<LoadMoreView isLoading />);
            }
            return null;
          })()}
        </LenspireView>
      );
    }
    if (this.props.isLoading) {
      return (
        <LenspireView {...this.props}>
          <LoadMoreView isLoading />
        </LenspireView>
      );
    }
    return (
      <LenspireView {...this.props}>
        <HeadlineModuleView>Sorry, no articles found.</HeadlineModuleView>
        <TextModuleView>Maybe you want to try some other categories?</TextModuleView>
      </LenspireView>
    );
  }
}

function mapStateToProps(state) {
  return {
    tilesData: state.tilesState.tiles,
    page: state.tilesState.page,
    hasNextPage: state.tilesState.hasNextPage,
    scrollPosition: state.tilesState.scrollPosition,
    meta: state.globalsState.meta,
    error: state.globalsState.error,
    lang: state.globalsState.lang,
    isLoading: state.loaderState.isLoading,
    counterHack: state.tilesState.counterHack,
  };
}

HomeView.propTypes = {
  tilesData: PropTypes.arrayOf(PropTypes.shape({
    headline: PropTypes.string,
    subline: PropTypes.string,
    image: PropTypes.oneOfType([
      PropTypes.shape({
        xxl: PropTypes.string,
        xl: PropTypes.string,
        lg: PropTypes.string,
        md: PropTypes.string,
        sm: PropTypes.string,
        default: PropTypes.string,
      }), PropTypes.array,
    ]),
  })),
  page: PropTypes.number,
  location: PropTypes.shape().isRequired,
  setLang: PropTypes.func.isRequired,
  fetchTiles: PropTypes.func.isRequired,
  fetchFilteredTiles: PropTypes.func.isRequired,
  setActiveSubCategories: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
  error: PropTypes.string,
  lang: PropTypes.string,
  isLoading: PropTypes.bool,
  resetTiles: PropTypes.func.isRequired,
  fetchSearchededTiles: PropTypes.func.isRequired,
  setScrollPosition: PropTypes.func.isRequired,
  hasNextPage: PropTypes.bool,
  scrollPosition: PropTypes.number,
  counterHack: PropTypes.number,
};

HomeView.defaultProps = {
  tilesData: [
    {
      headline: '',
      subline: '',
      image: {},
    },
  ],
  error: '',
  lang: 'en',
  hasNextPage: false,
  isLoading: false,
  scrollPosition: 0,
  page: 0,
  counterHack: 0,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setLang, setActiveSubCategories, fetchTiles, fetchFilteredTiles, fetchSearchededTiles, resetTiles, setScrollPosition }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeView));



// WEBPACK FOOTER //
// ./frontend/js/Views/HomeView/HomeView.jsx